import { createContext, useState } from 'react';


export const AuthContext = createContext<any>(null);

export const AuthProvider = ({ children }:any) => {
    const [authenticated, setAuthenticated] = useState(localStorage.getItem('token'));

    return (
        <AuthContext.Provider value={{ authenticated, setAuthenticated,}}>
            {children}
        </AuthContext.Provider>
    );
};
